import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const wizzardRecalculatePricesObj = createSelector(wizzardState, (wizzard) => wizzard.recalculatePrices);
